import { findActive, loadStore, setActive } from './identityStore';
import { DB_NAME, HOST } from './config';
import {
  notifyIdentityStoreUpdate,
  setActiveTokenHash,
  setSessionState,
} from './hooks';

const buttonStyle: React.CSSProperties = {
  background: '#e09020',
  color: '#1a1208',
  border: 'none',
  padding: '14px 36px',
  fontSize: 18,
  borderRadius: 6,
  cursor: 'pointer',
  fontFamily: 'inherit',
  letterSpacing: 0.5,
};

const secondaryButton: React.CSSProperties = {
  ...buttonStyle,
  background: 'transparent',
  color: '#e7d9b6',
  border: '1px solid #2a3445',
  padding: '12px 24px',
  fontSize: 14,
};

/**
 * Welcome-back screen: shown when the user has an active identity saved
 * locally and we haven't connected yet. Two explicit choices instead of a
 * silent auto-login.
 */
export function WelcomeBack() {
  // Snapshot the active identity at render time. We don't subscribe to
  // store changes here — the only outgoing transitions update sessionState,
  // which causes the parent (SessionGuard) to render something else.
  const store = loadStore(HOST, DB_NAME);
  const active = findActive(store);
  const displayName = active?.lastKnownUserName ?? active?.localLabel ?? 'friend';

  const enter = () => {
    setSessionState('CONNECTING');
  };

  const logOut = () => {
    setActive(HOST, DB_NAME, null);
    setActiveTokenHash('');
    setSessionState('IDENTITY_SELECT');
    notifyIdentityStoreUpdate();
  };

  return (
    <div
      style={{
        height: '100vh',
        width: '100vw',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background:
          'radial-gradient(circle at 50% 35%, #1a2438 0%, #0a0e18 70%)',
        color: '#e7d9b6',
        fontFamily: 'Georgia, serif',
        textAlign: 'center',
      }}
    >
      <div style={{ maxWidth: 480, padding: 24 }}>
        <p
          style={{
            fontSize: 14,
            opacity: 0.55,
            margin: 0,
            letterSpacing: 1,
            textTransform: 'uppercase',
          }}
        >
          Welcome back
        </p>
        <h1
          style={{
            fontSize: 40,
            margin: '6px 0 4px',
            fontWeight: 400,
          }}
        >
          {displayName}
          {active?.lastKnownIsAdmin && (
            <span
              style={{
                marginLeft: 10,
                fontSize: 12,
                background: '#e09020',
                color: '#1a1208',
                padding: '2px 8px',
                borderRadius: 4,
                verticalAlign: 'middle',
              }}
            >
              ADMIN
            </span>
          )}
        </h1>
        <p style={{ opacity: 0.6, fontStyle: 'italic', marginBottom: 32 }}>
          The forest remembers you.
        </p>
        <div
          style={{
            display: 'flex',
            gap: 12,
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <button onClick={enter} style={buttonStyle}>
            Continue your adventure →
          </button>
          <button onClick={logOut} style={secondaryButton}>
            Log out
          </button>
        </div>
      </div>
    </div>
  );
}
